import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, Truck, RotateCcw, CreditCard } from 'lucide-react';
import { categories } from '../data/categories';
import { products } from '../data/products';
import { ProductCard } from '../components/ProductCard';
export function Home() {
  const featuredProducts = products.filter(p => p.isFeatured).slice(0, 8);
  const saleProducts = products.filter(p => p.salePrice).slice(0, 4);
  return <div className="flex flex-col min-h-screen" data-id="element-411">
      {/* Hero Section */}
      <section className="relative h-[80vh] min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-412">
        <div className="absolute inset-0 z-0" data-id="element-413">
          <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&q=80&w=2000" alt="Beautiful beach in Maldives" className="w-full h-full object-cover" data-id="element-414" />
          <div className="absolute inset-0 bg-black/30" data-id="element-415" />
        </div>

        <div className="relative z-10 text-center px-4 max-w-3xl mx-auto" data-id="element-416">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tight" data-id="element-417">
            Sun, Sand & Style
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-418">
            Discover our curated collection of premium beachwear, accessories,
            and essentials for your perfect island getaway.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-419">
            <Link to="/shop" className="px-8 py-3.5 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors shadow-lg" data-id="element-420">
              Shop Now
            </Link>
            <Link to="/shop/swimwear" className="px-8 py-3.5 bg-white text-gray-900 rounded-lg font-medium hover:bg-gray-50 transition-colors shadow-lg" data-id="element-421">
              Browse Swimwear
            </Link>
          </div>
        </div>
      </section>

      {/* Trust/Benefits Row */}
      <section className="bg-white border-b border-gray-200 py-8" data-id="element-422">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-423">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-gray-100" data-id="element-424">
            <div className="flex flex-col items-center px-4" data-id="element-425">
              <Truck className="w-6 h-6 text-red-600 mb-3" data-id="element-426" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-427">
                Free Shipping
              </h3>
              <p className="text-xs text-gray-500 mt-1" data-id="element-428">
                On orders over MVR 500
              </p>
            </div>
            <div className="flex flex-col items-center px-4" data-id="element-429">
              <RotateCcw className="w-6 h-6 text-red-600 mb-3" data-id="element-430" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-431">
                Easy Returns
              </h3>
              <p className="text-xs text-gray-500 mt-1" data-id="element-432">14-day return policy</p>
            </div>
            <div className="flex flex-col items-center px-4" data-id="element-433">
              <CreditCard className="w-6 h-6 text-red-600 mb-3" data-id="element-434" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-435">
                Secure Checkout
              </h3>
              <p className="text-xs text-gray-500 mt-1" data-id="element-436">Powered by BML</p>
            </div>
            <div className="flex flex-col items-center px-4" data-id="element-437">
              <ShieldCheck className="w-6 h-6 text-red-600 mb-3" data-id="element-438" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-439">
                Local Shop
              </h3>
              <p className="text-xs text-gray-500 mt-1" data-id="element-440">Based in Maldives</p>
            </div>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-16 bg-gray-50" data-id="element-441">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-442">
          <div className="flex justify-between items-end mb-8" data-id="element-443">
            <div data-id="element-444">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-445">
                Shop by Category
              </h2>
              <p className="text-gray-500 mt-1" data-id="element-446">
                Find exactly what you need for the beach
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-447">
            {categories.map(category => <Link key={category.id} to={`/shop/${category.id}`} className="group relative h-64 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-448">
                <img src={category.image} alt={category.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-449" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" data-id="element-450" />
                <div className="absolute bottom-0 left-0 p-6" data-id="element-451">
                  <h3 className="text-xl font-bold text-white mb-1" data-id="element-452">
                    {category.name}
                  </h3>
                  <p className="text-sm text-white/80" data-id="element-453">
                    {category.productCount} Products
                  </p>
                </div>
              </Link>)}
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="py-16 bg-white" data-id="element-454">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-455">
          <div className="flex justify-between items-end mb-8" data-id="element-456">
            <div data-id="element-457">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-458">
                Featured Products
              </h2>
              <p className="text-gray-500 mt-1" data-id="element-459">
                Our most popular items this season
              </p>
            </div>
            <Link to="/shop" className="hidden sm:flex items-center text-red-600 font-medium hover:text-red-700" data-id="element-460">
              View All <ArrowRight className="w-4 h-4 ml-1" data-id="element-461" />
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-462">
            {featuredProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-463" />)}
          </div>

          <div className="mt-8 text-center sm:hidden" data-id="element-464">
            <Link to="/shop" className="inline-flex items-center text-red-600 font-medium hover:text-red-700" data-id="element-465">
              View All Products <ArrowRight className="w-4 h-4 ml-1" data-id="element-466" />
            </Link>
          </div>
        </div>
      </section>

      {/* On Sale Strip */}
      {saleProducts.length > 0 && <section className="py-16 bg-red-50 border-y border-red-100" data-id="element-467">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-468">
            <div className="flex justify-between items-end mb-8" data-id="element-469">
              <div data-id="element-470">
                <h2 className="text-2xl font-bold text-red-900" data-id="element-471">
                  Special Offers
                </h2>
                <p className="text-red-700/80 mt-1" data-id="element-472">
                  Grab these deals before they're gone
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6" data-id="element-473">
              {saleProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-474" />)}
            </div>
          </div>
        </section>}
    </div>;
}